<template>
<!-- 活动-组队活动-活动列表 -->
    <div class="container">
        <div class="handle-box-search">
            <div class="handle-box">
                <el-row class="head-search">
                    <el-col :span="24">
                        <span class="title">活动名称:</span>
                        <!-- 搜索活动名称 -->
                        <el-input
                            v-model="search_data.name"
                            placeholder="请输入活动名称"
                            class="handle-input mr10"
                            @keyup.enter.native="searchGroupactivitylists"
                        ></el-input>
                    </el-col>
                </el-row>
            </div>
            <el-button type="primary" icon="el-icon-search" @click="searchGroupactivitylists">搜索</el-button>
            <el-button @click="add_show = !add_show">添加</el-button>
            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>
        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header">
            <el-table-column prop="name" label="活动名称"> </el-table-column>

            <el-table-column prop="group_num" label="组队人数"> </el-table-column>
            <el-table-column prop="hour" label="时长"> </el-table-column>

            <el-table-column prop="coupon_mode_code" label="优惠券编码"> </el-table-column>

            <el-table-column prop="join_num" label="参与次数"></el-table-column>
            <el-table-column prop="coupon_name" label="优惠券名称"></el-table-column>
            <el-table-column prop="is_new_consumer.alias" label="限制新老用户"></el-table-column>
            <el-table-column prop="send_type.alias" label="双向发放"></el-table-column>
            <el-table-column prop="type.alias" label="开关状态"></el-table-column>
            <el-table-column prop="time.YmdHis" label="时间"></el-table-column>
            <el-table-column prop="city.name" label="城市"></el-table-column>

            <el-table-column width="150" label="操作">
                <template slot-scope="scope">
                    <el-button
                        :type="scope.row.type.val == '0' ? 'primary' : 'danger'"
                        @click="executeTypeSubmit(scope.row.group_activity_code, scope.row.type.val)"
                        :disabled="scope.row.type.val == 3"
                        >{{ scope.row.type.val == '0' ? '开' : '关' }}</el-button
                    >
                    <!-- <el-button type="primary" @click="deleteData(scope.row.group_activity_code)">删除</el-button> -->
                </template>
            </el-table-column>
        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>

        <!-- 添加组件 -->
        <addGroupActivitySubmit :isShow="add_show" @onSubmit="groupactivitylists"></addGroupActivitySubmit>
    </div>
</template>

<script>
var _this;
import addGroupActivitySubmit from './addGroupActivitySubmit.vue';

export default {
    components: {
        addGroupActivitySubmit
    },

    data() {
        return {
            add_show: false,
            edit_show: false,
            edit_data: '',

            // 存放表格数据
            tableData: [],

            //翻页数据
            search_data: {
                page: 1,
                limit: 10
            },

            result_data: [],
            search_rules: {
                page: {
                    placeholder: '页码',
                    rules: {
                        required: true,
                        message: '页码需要大于0',
                        regulation: 'gt',
                        rulesData: 0
                    }
                },
                limit: {
                    placeholder: '每页个数',
                    rules: {
                        required: true,
                        message: '每页个数需在1-51之内',
                        regulation: 'between',
                        rulesData: [1, 51]
                    }
                }
            }
        };
    },
    created() {
        _this = this;
        _this.groupactivitylists();
    },

    methods: {
        executeTypeSubmit(code, type) {
            var sub_type = '';

            if (type == '0') {
                sub_type = '1';
            } else if (type == '1') {
                sub_type = '0';
            }

            _this
                .$post('/groupactivity/editGroupActivitySubmit', {
                    group_activity_code: code,
                    type: sub_type
                })
                .then((res) => {
                    _this.$message.success(res.msg);
                    _this.groupactivitylists();
                })
                .catch((err) => {});
        },

        // 删除
        deleteData(code) {
            _this
                .$confirm('此操作将删除该条数据, 是否继续?', '提示', {
                    confirmButtonText: '确定',

                    cancelButtonText: '取消',

                    type: 'warning'
                })
                .then(() => {
                    _this
                        .$post('/groupactivity/deleteGroupActivitySubmit', {
                            group_activity_code: code
                        })
                        .then((res) => {
                            console.log(res);

                            _this.$message.success('删除成功!');

                            //初始化显示列表
                            _this.groupactivitylists();

                            return;
                        })
                        .catch((err) => {
                            console.log(err);
                        });
                })
                .catch(() => {
                    _this.$message.info('已取消删除');
                });
        },

        searchGroupactivitylists() {
            _this.search_data.page = 1;
            _this.groupactivitylists();
        },
        // 搜索司机日志列表
        groupactivitylists() {
            _this
                .$post('/groupactivity/groupactivitylists', _this.search_data, _this.search_rules)
                .then((res) => {
                    // 将请求的数据存放到表格数据数组中
                    _this.tableData = res.data;
                    _this.result_data = res;
                })
                .catch((err) => {});
        },
        //翻页组件的回调
        pages_function(search_data) {
            //赋值
            _this.search_data = search_data;
            //初始化列表
            _this.groupactivitylists();
        },

        // 刷新按钮
        refresh() {
            this.$router.go(0);
        }
    }
};
</script>

<style scoped>
.handle-box {
    margin-bottom: 20px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 200px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
}

.table-td-thumb {
    display: block;
    margin: auto;
    width: 40px;
    height: 40px;
}

.el-table__row {
    height: 100px;
}

.el-form-item.el-form-item--small {
    width: 100%;
}

.demo-table-expand {
    font-size: 0;
}

.demo-table-expand label {
    width: 90px;
    color: #99a9bf;
}

.demo-table-expand .el-form-item {
    margin-right: 0;
    margin-bottom: 0;
}

.el-form-item__content span {
    display: inline-block;
    width: 100%;
    word-wrap: break-word;
    white-space: normal;
}
</style>
